import { types } from 'mobx-state-tree'

export enum Months {
  Jan = 'January',
  Feb = 'February',
  Mar = 'March',
  Apr = 'April',
  May = 'May',
  Jun = 'June',
  Jul = 'July',
  Aug = 'August',
  Sep = 'September',
  Oct = 'October',
  Nov = 'November',
  Dec = 'December',
}

const Invoice = types.model('Invoice', {
  id: types.optional(types.string, ''),
  year: types.optional(types.string, ''),
  month: types.enumeration(Object.values(Months)),
  file: types.optional(types.string, ''),
})

const InvoiceData1 = Invoice.create({
  id: '1',
  year: '2020',
  month: Months.Jan,
  file: 'invoice1.pdf',
})

const InvoiceData2 = Invoice.create({
  id: '2',
  year: '2020',
  month: Months.Feb,
  file: 'invoice2.pdf',
})

const InvoiceData3 = Invoice.create({
  id: '3',
  year: '2020',
  month: Months.Mar,
  file: 'invoice3.pdf',
})

const InvoiceData4 = Invoice.create({
  id: '4',
  year: '2020',
  month: Months.Apr,
  file: 'invoice4.pdf',
})

const InvoiceData5 = Invoice.create({
  id: '5',
  year: '2019',
  month: Months.Jan,
  file: 'invoice5.pdf',
})
export { Invoice, InvoiceData1, InvoiceData2, InvoiceData3, InvoiceData4, InvoiceData5 }
